import React, {useState} from 'react'
import {Button} from '@material-ui/core'

const ApprovalButtons = ({onClickReject = (e, data) => {}, onClickApprove = (e, data) => {}}) => {
  const [axn, setAxn] = useState(null)
  const [message, setMessage] = useState('')

  const handleClickAxn = (e, axn) => {
    setAxn(axn)
  }

  const handleClickConfirm = e => {
    if (axn === 'approved') {
      onClickApprove(e, {message: message})
    } else if (axn === 'rejected') {
      onClickReject(e, {message: message})
    }
  }

  return (
    <>
      {!axn && (
        <>
          <Button
            className="ap-button ap-button--primary font-bold radius-4 save-btn mt--1 text-white"
            onClick={e => handleClickAxn(e, 'approved')}
          >
            Approve
          </Button>
          <Button
            className="ap-button ap-button--danger font-bold radius-4 delete-btn mt--1 text-white"
            onClick={e => handleClickAxn(e, 'rejected')}
          >
            Reject
          </Button>
        </>
      )}
      {axn && (
        <div
          style={{
            display: 'flex',
            width: '100%',
            alignItems: 'center',
          }}
        >
          <input
            className="ap-typography ap-flex ap-mr-2 ap-b-gray ap-b ap-p-2 input-placholder"
            type="text"
            value={message}
            onChange={e => setMessage(e.target.value)}
            placeholder="Optional comment"
          />
          <Button
            className={`ap-button font-bold radius-4 mt--1 text-white ${
              axn === 'approved' ? 'ap-button--primary save-btn' : 'ap-button--danger delete-btn'
            }`}
            onClick={handleClickConfirm}
          >
            {axn === 'approved' ? 'Approve' : 'Reject'}
          </Button>
        </div>
      )}
    </>
  )
}

export default ApprovalButtons
